import React from 'react';
import { useFela } from 'react-fela';
import PropTypes from 'prop-types';
import { formatHhMmSs } from '../../utils';

const THUMBNAIL_SCALE = 0.7;
const calculateMargin = (thumbnail) => {
  const scale = (THUMBNAIL_SCALE - 1) / 2;
  const lrm = (thumbnail.width - 1) * scale;
  const tbm = thumbnail.height * scale;
  return `${tbm}px ${lrm}px`;
};

const tooltip = ({ tooltipPosX }) => ({
  position: 'absolute',
  left: `${tooltipPosX}px`,
  bottom: '20px',
  backgroundColor: '#252525',
  transform: 'translateX(-50%)',
});

const img = ({ thumbnail }) => ({
  width: `${thumbnail.width - 1}px`,
  height: `${thumbnail.height - 1}px`,
  backgroundImage: `url(${thumbnail.uris[0]})`,
  backgroundPosition: `-${thumbnail.positionX}px -${thumbnail.positionY}px`,
  // reduce thumbnail size
  transform: `scale(${THUMBNAIL_SCALE})`,
  margin: calculateMargin(thumbnail),
});

const time = () => ({
  padding: '0 20px',
  lineHeight: '39px',
  fontSize: '1.25rem',
  color: 'white',
});

const mark = () => ({
  position: 'absolute',
  width: 1,
  height: 12,
  backgroundColor: 'white',
  left: '50%',
  marginLeft: '-1px',
  bottom: -22,
  // hide mark under progress dot (Thumb)
  pointerEvents: 'none',
  zIndex: 1,
});

function Thumbnail({ hoverTime, tooltipPosX, thumbnail }) {
  const { css } = useFela({ tooltipPosX, thumbnail });

  return (
    hoverTime !== null ? (
      <div className={css(tooltip)}>
        {thumbnail && (
          <div className={css(img)} />
        )}
        <div className={css(time)}>{formatHhMmSs(hoverTime)}</div>
        <div className={css(mark)} />
      </div>
    ) : null
  );
}

const thumbnailShape = PropTypes.shape({
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  positionX: PropTypes.number.isRequired,
  positionY: PropTypes.number.isRequired,
  uris: PropTypes.arrayOf(PropTypes.string).isRequired,
});

Thumbnail.propTypes = {
  hoverTime: PropTypes.number,
  tooltipPosX: PropTypes.number,
  thumbnail: thumbnailShape,
};

export default React.memo(Thumbnail);
